/**
 * Created by stonewang on 2017/8/18.
 */
import React from 'react';
import { Modal, Button, Form, Input,InputNumber } from 'antd';
import PropTypes from 'prop-types';
const FormItem = Form.Item;
const { TextArea } = Input;

class AdjustModal extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      num: '',
      desc: '',
      hasChange: false,
      inputSuccess: false,
    }
    this.handleOk = this.handleOk.bind(this);
    this.resetModal = this.resetModal.bind(this);
  }

  handleOk () {
    const { num, desc, inputSuccess, hasChange } = this.state;
    if(hasChange){
      inputSuccess && this.props.onOk({ num, desc });
    }else {
      this.setState({ hasChange: !hasChange });
    }
  }

  componentWillReceiveProps (newProps) {
    if (newProps.visible) {
      this.resetModal();
    }
  }

  changeHandle (name, e) {
    if (name === 'num') {
      this.setState({
        [name]: e,
        hasChange: true,
        inputSuccess: e!==null && e!==undefined && e!=='',
      });
    } else {
      this.setState({
        [name]: e.target.value,
      });
    }
  }

  resetModal () {
    this.setState({
      ...this.state,
      num: '',
      desc: '',
      hasChange: false,
      inputError: false,
    })
  }

  render () {
    const self = this;
    const data = this.props.data;
    const modalOpts = {
      title: '库存调整',
      visible: self.props.visible,
      onCancel: self.props.onCancel,
      footer: [
        <Button key="0" size="large" onClick={self.props.onCancel}>取消</Button>,
        <Button key="1" type="primary" size="large" onClick={self.handleOk}>
          确定
        </Button>,
      ]
    };

    return (
      <Modal {...modalOpts} width={500}>
        <Form layout="horizontal">
          <FormItem label="库存数量">
            <InputNumber min={0} value={this.state.num} defaultValue={data.addOrSubtractNum||0} onChange={this.changeHandle.bind(this, 'num')} />
          </FormItem>
          <FormItem label="描述">
            <TextArea rows={4} value={this.state.desc} onChange={this.changeHandle.bind(this, 'desc')} />
          </FormItem>
        </Form>
      </Modal>
    )
  }
}
AdjustModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onOk: PropTypes.func.isRequired
};
export default AdjustModal;


// WEBPACK FOOTER //
// ./src/routes/inventory/adjustModal.js